(function(app) {

    app.filter("telephone",
    [
        function() {
            return function(value) {
                if (value) {
                   
                    if (value.length >= 9) {
                        var test1 = value.substr(0, 3);
                        var test2 = value.substr(3, 3);
                        var test3 = value.substr(6, 4);
                        return test1 + "-" + test2 + "-" + test3;
                    }
                    else if (value.length >= 6)
                        return value.substr(0, 3) + "-" + value.substr(3, 3) + "-" + value.substr(6, 4);
                    else if (value.length >= 3)
                        return value.substr(0, 3) + "-" + value.substr(3);
                }
                return value;
            }
        }
    ]);

    app.filter("telephoneReverse",
    [
        function() {
            return function(value) {
                if (value) return value.replace(/-/g, "");
                return value;
            }
        }
    ]);

})(window.app); //jshint ignore:line